import React, { useEffect, useRef, useState } from "react";
import Tree from "react-d3-tree";

export default function Thing({ tree, key, separation = 2 }) {
  const [x, setX] = useState(300);
  const [y, setY] = useState(50);
  const [update, forceUpdate] = useState({});

  const containerRef = useRef(null);

  useEffect(() => {
    const dimensions = containerRef.current.getBoundingClientRect();
    setX(dimensions.width / 2 - 50);
    setY(dimensions.height / 2 - 50);
  }, []);

  return (
    <div id="treeWrapper" orientation="vertical" ref={containerRef}>
      {key && (
        <div className="key">
          <ul>
            <li>
              <svg style={{ display: "inline-block", width: 20, height: 20, marginRight: 10 }}>
                <rect width="20" height="20" fill="red" strokeWidth="0" />
              </svg>
              <span>Original Sample</span>
            </li>
            <li>
              <svg style={{ display: "inline-block", width: 20, height: 20, marginRight: 10 }}>
                <circle r="10" fill="blue" strokeWidth="0" cx="10" cy="10" />
              </svg>
              <span>Transport Logistics Record</span>
            </li>
            <li>
              <svg style={{ display: "inline-block", width: 20, height: 10, marginRight: 10 }}>
                <rect width="10" height="10" fill="orange" strokeWidth="0" />
              </svg>
              <span>Aliquot</span>
            </li>
          </ul>
        </div>
      )}
      <Tree
        orientation="vertical"
        data={tree}
        translate={{ x: x, y: 80 }}
        separation={{ siblings: separation, nonSiblings: separation }}
        allowForeignObjects
        nodeLabelComponent={{
          render: <NodeLabel className="myLabel" />,
          foreignObjectWrapper: {
            x: 20,
            y: -10
          }
        }}
      />
    </div>
  );
}

class NodeLabel extends React.PureComponent {
  render() {
    const { className, nodeData } = this.props;
    return (
      <div className={className}>
        <p className="title">{nodeData.name}</p>
        {Object.entries(nodeData.attributes).map(attribute =>
          attribute[0] == "id" ? (
            <a href={"/tracking/items/" + attribute[1]}>View</a>
          ) : (
            <p className="attributes" key={attribute[0]}>
              {attribute[0]}: {attribute[1]}
            </p>
          )
        )}

        {/* {nodeData._children && <button>{nodeData._collapsed ? "Expand" : "Collapse"}</button>} */}
      </div>
    );
  }
}
